import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)}px;
`;

export const AvatarsContainer = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: -${({ theme }) => theme.spacing(4)}px;
  }
`;

export const AvatarWrapper = styled.div`
  border-radius: 999px;
  border: 2px solid ${({ theme }) => theme.colors.on[0]};
`;

export const OverflowAvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)}px;
`;
